import { debounce } from "lodash-es";
import { useEffect } from "react";
import { useMap } from "react-leaflet";

export const MapSizeObserver = () => {
  const map = useMap();

  useEffect(() => {
    const container = map.getContainer();
    const debouncedInvalidate = debounce(() => {
      try {
        map.invalidateSize({ animate: true });
      } catch {
        // Map may already be destroyed after unmount
      }
    }, 1);

    const ro = new ResizeObserver(() => debouncedInvalidate());
    ro.observe(container);

    return () => {
      debouncedInvalidate.cancel();
      ro.disconnect();
    };
  }, [map]);

  return null;
};
